import { app } from '../../../app';

class Service {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getSmsGatewayList(mobilePhoneNumber) {
        return this.$http
            .get(`app/rest/smsotp/smsgateways/${mobilePhoneNumber}`)
            .then((response) => response.data);
    }
}

app.service('SmsGatewaysService', Service);



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-otp/sms-gateways.service.js